var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceplaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3639 2.63611C14.529 1.7991 13.537 1.13533 12.4448 0.68294C11.3526 0.230548 10.1818 -0.00154171 8.9996 7.70694e-06C4.02895 7.70694e-06 6.45041e-06 4.02976 6.45041e-06 8.9996C-0.00141083 10.1818 0.23074 11.3526 0.683124 12.4447C1.13551 13.5369 1.79921 14.529 2.63611 15.3639C3.47096 16.2009 4.46299 16.8647 5.55519 17.3171C6.64739 17.7694 7.81822 18.0015 9.0004 18C13.971 18 18 13.9702 18 9.0004C18.0014 7.81824 17.7693 6.64745 17.3169 5.55527C16.8645 4.46309 16.2008 3.47104 15.3639 2.63611ZM9.0004 16.7937C4.70286 16.7937 1.20708 13.2971 1.20708 9.0004C1.20708 4.70366 4.70366 1.20708 9.0004 1.20708C13.2971 1.20708 16.7937 4.70366 16.7937 9.0004C16.7937 13.2971 13.2971 16.7937 9.0004 16.7937Z",
    fill: "#FF4E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64416 11.3334L4.85883 8.63099L4 9.46427L7.64416 13L14 6.83328L13.1412 6L7.64416 11.3334Z",
    fill: "#FF4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceplaceholder);
export default __webpack_public_path__ + "static/media/serviceplaceholder.2ebf89042c17fc2eb81cf4bea90a8437.svg";
export { ForwardRef as ReactComponent };